import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "react-table/react-table.css";
import PPIDetailComponent from "./ppi-detail-component";
import PPIFormContainer from "../ppi-form/ppi-form-container";
import * as actionCreators from "../../../action-creators";
import PPIService from "../../../service/sfp/ppi-service";
import * as LoansService from "../../../service/sfp/loans-service-2";
import PPIYearService from "../../../service/sfp/ppi-year-service";
import PPIRevenueYearService from "../../../service/sfp/ppi-revenue-year-service";
import PPIExpenseYearService from "../../../service/sfp/ppi-expense-year-service";
import UsersService from "../../../service/sfp/users-service";
import GrantsService from "../../../service/sfp/grant-service";
import ScenarioService from "../../../service/sfp/scenario-service";

import InvestmentsHelper from "./utils/investments-helper";

import {
    getYearInterest,
    getYearRemainingCapital,
    getYearReimboursedCapital,
    getLoansWithDecomposition,
    geteDcompositionWithLoans,
} from "../../../domain/sfp/loan-domain";
import { getProfile, Profile } from "../../../domain/sfp/user-domain";

import Spinner from "react-spinkit";

import moment from "moment";

import TableDefinition from "./table-rows";

import worker from "./ppi-worker";

class PPIDetailContainer extends React.Component {
    state = {
        global_loading: false,
        shownThemes: [],
        priorities: [],
        previousYear: false,
        current_year: parseInt(moment().format("YYYY")),
        as_responsible: false,
        currentUser: {
            id: 1,
        },
        currentWorkerUid: null,
        shownGrants: [],
        scenario: undefined,
        projectsData: {},
        data: [],
        tableDef: { rows: [] },
        findScenario: false,
        loadingGrants: false,
        loadingLoans: false,
        loadingPpi: false,
        loadingScenario: false,
        loadingUsers: false,
    };

    getChildContext() {
        return {
            onCustomAction: this._handleCustomAction.bind(this)
        }
    }

    componentDidMount() {
        
        const consulted =
            getProfile(this.props.currentUser) === Profile.LocalAuthorityConsultant;
        this.props.actions.setPageTitle("PPI");
        if (this.props.currentLocalAuthority) {
            this._loadPPI(this.props.currentLocalAuthority.id);
        }
        this.props.currentLocalAuthority &&
            ScenarioService.findCurrentValidatedScenario(
                this.props.currentLocalAuthority.id
            ).then(:: this._resolveFindScenario, :: this._rejectFindScenario);
        var self = this;
        this.worker = new Worker(
            URL.createObjectURL(new Blob(["(" + worker.toString() + ")()"]))
        );
        this.worker.addEventListener("message", function (e) {
            if (self.state.currentWorkerUid == e.data.uid) {
                let def = TableDefinition(
                    self.state.ppi,
                    self.state.as_responsible,
                    self.state.current_year,
                    self.state.shownGrants,
                    self.props.currentLocalAuthority,
                    self.state.scenario
                );
                
                consulted ? self._modifyingTabDef(def) : null;
                let data = [];

                def.rows.map((row) => {
                    data.push(e.data.data[row.key]);
                    if (data[data.length - 1]) {
                        data[data.length - 1].unshift(row.title);
                    }
                });
                let projectsRows = InvestmentsHelper(
                    self.state.ppi,
                    self.state.shownThemes,
                    self.state.priorities,
                    self.state.current_year,
                    consulted
                );
                self.setState({
                    data,
                    tableDef: def,
                    projectsData: { data: e.data.projectsData, rows: projectsRows },
                    global_loading: false,
                });
            }
        });
    }

    componentWillUnmount() {
        if (this._getDataDebounceTimer) {
            clearTimeout(this._getDataDebounceTimer);
        }
        if (this.worker) {
            this.worker.terminate();
        }
    }

    componentWillReceiveProps(props) {
        if (props.currentLocalAuthority) {
            this._loadPPI(props.currentLocalAuthority.id);
            ScenarioService.findCurrentValidatedScenario(
                props.currentLocalAuthority.id
            ).then(:: this._resolveFindScenario, :: this._rejectFindScenario);

            // Recalculate if simplified debt data changed on the same local authority
            if (
                this.props.currentLocalAuthority &&
                props.currentLocalAuthority.id === this.props.currentLocalAuthority.id &&
                props.currentLocalAuthority.localAuthorityDebtSimplifiedYears !== this.props.currentLocalAuthority.localAuthorityDebtSimplifiedYears &&
                this.state.ppi && this.state.scenario
            ) {
                this._getData();
            }
        }
    }

    _loadPPI(LAId) {
        if (
            !this.state.loadingPpi &&
            (!this.state.ppi || this.state.ppi.localAuthority.id !== LAId)
        ) {
            this.setState(
                { ppi: null, loadingPpi: true, loadingStr: "Chargement du PPI" },
                () => {
                    PPIService.findPPIByLAId(LAId).then(
                        :: this._resolveFindPPI,
                        :: this._rejectFindPPI
                    );
                }
            );
        }
    }

    render() {
        const consulted =
            getProfile(this.props.currentUser) === Profile.LocalAuthorityConsultant;

        if (this._isLoading()) {
            return (
                <div className="ppi-loader">
                    <Spinner fadeIn="none" name="wave" color="#3d3c3f" />
                    <span>{this.state.loadingStr}</span>
                </div>
            );
        } else if (this.state.notFound) {
            return (
                <PPIFormContainer
                    localAuthority={this.props.currentLocalAuthority}
                    onCreated={this._resolveFindPPI.bind(this)}
                    scenario={this.state.scenario}
                />
            );
        } else if (this.state.scenario) {
            return (
                <PPIDetailComponent
                    pageTitle={this.props.pageTitle}
                    scenario={this.state.scenario}
                    selectedPriorities={this.props.selectedPriorities}
                    consulted={consulted}
                    globalLoading={this.state.global_loading}
                    asResponsible={this.state.as_responsible}
                    current_year={this.state.current_year}
                    actions={this.props.actions}
                    action={this.state.action}
                    actionData={this.state.actionData}
                    ppi={this.state.ppi}
                    projectsData={this.state.projectsData}
                    currentUser={this.state.currentUser}
                    currentUserType={this.props.currentUser.userType}
                    users={this.state.users}
                    grants={this.state.grants}
                    priorities={this.state.priorities}
                    previousYear={this.state.previousYear}
                    data={this.state.data}
                    tableDefinition={this.state.tableDef}
                    currentLocalAuthority={this.props.currentLocalAuthority}
                    shownThemes={this.state.shownThemes}
                    onChange={this._handleChange.bind(this)}
                    onHidePopup={this._handleHidePopup.bind(this)}
                    onCustomAction={this._handleCustomAction.bind(this)}
                    onPrioritiesChange={this._handlePrioritiesChanged.bind(this)}
                    onTogglePreviousYear={this._handleTogglePreviousYear.bind(this)}
                    onToggleAsResponsible={() => {
                        this.setState({ as_responsible: !this.state.as_responsible });
                    }}
                    onYearAdded={this._handleYearAdded.bind(this)}
                    onLastYearDeleted={this._handleLastYearDeleted.bind(this)}
                    onRevenueCreated={this._handleRevenueCreated.bind(this)}
                    onRevenueUpdated={this._handleRevenueUpdated.bind(this)}
                    onRevenueDeleted={this._handleRevenueDeleted.bind(this)}
                    onExpenseCreated={this._handleExpenseCreated.bind(this)}
                    onExpenseUpdated={this._handleExpenseUpdated.bind(this)}
                    onExpenseDeleted={this._handleExpenseDeleted.bind(this)}
                    onThemeCreated={this._handleThemeCreated.bind(this)}
                    onThemeUpdated={this._handleThemeUpdated.bind(this)}
                    onThemeDeleted={this._handleThemeDeleted.bind(this)}
                    onProjectCreated={this._handleProjectCreated.bind(this)}
                    onProjectUpdated={this._handleProjectUpdated.bind(this)}
                    onProjectDeleted={this._handleProjectDeleted.bind(this)}
                    onGrantCreated={this._handleGrantCreated.bind(this)}
                    onGrantUpdated={this._handleGrantUpdated.bind(this)}
                    onGrantDeleted={this._handleGrantDeleted.bind(this)}
                    onGrantToggled={this._handleGrantUpdated.bind(this)}
                    onInducedsSaved={this._handleProjectUpdated.bind(this)}
                    onThemeToggle={this._handleToggleTheme.bind(this)}
                    onToggleGrantTheme={this._handleToggleGrantTheme.bind(this)}
                    onToggleGrants={this._handleToggleGrants.bind(this)}
                    onProjectsDataBuild={this._handleProjectsDataBuild}
                    onProjectToggle={this._handleToggleProject.bind(this)}
                />
            );
        } else {
            return (
                <div className="ppi-loader">
                    Aucun scénario n'est validé pour l'année en cours.
                </div>
            );
        }
    }

    _getDataImmediate = () => {
        this.setState({ currentWorkerUid: guid(), global_loading: true }, () => {
            this.worker.postMessage({
                uid: this.state.currentWorkerUid,
                //def: TableDefinition(this.state.ppi, this.state.as_responsible, this.state.current_year, this.state.shownGrants, this.props.currentLocalAuthority, this.state.scenario),
                ppi: this.state.ppi,
                shownThemes: this.state.shownThemes,
                priorities: this.state.priorities,
                current_year: this.state.current_year,
                as_responsible: this.state.as_responsible,
                shownGrants: this.state.shownGrants,
                currentLocalAuthority: {
                    id: this.props.currentLocalAuthority.id,
                    accounts: this.props.currentLocalAuthority.accounts,
                    observations: this.props.currentLocalAuthority.observations,
                    isDebtSimplified: this.props.currentLocalAuthority.isDebtSimplified,
                    localAuthorityDebtSimplifiedYears: this.props.currentLocalAuthority.localAuthorityDebtSimplifiedYears
                },
                scenario: this.state.scenario,
                // loansWithDecomposition: getLoansWithDecomposition(props.currentLocalAuthorityLoans) }),
                loans: this.state.loans,
            });
        });
    };

    _getDataDebounceTimer = null;

    _getData = () => {
        if (this._getDataDebounceTimer) {
            clearTimeout(this._getDataDebounceTimer);
        }
        if (!this.state.global_loading) {
            this.setState({ global_loading: true });
        }
        this._getDataDebounceTimer = setTimeout(() => {
            this._getDataDebounceTimer = null;
            this._getDataImmediate();
        }, 100);
    };

    _dispatchReceiveError(error) {
        this.props.actions.throwError(error);
    }

    _isLoading() {
        return (
            this.state.loadingScenario ||
            this.state.loadingPpi ||
            this.state.loadingGrants ||
            this.state.loadingLoans ||
            this.state.loadingUsers
        );
    }

    _modifyingTabDef(def) {
        def.FCTVA.readOnly = true;
        def.FCTVA_RETRIEVE.readOnly = true;
        def.PLANNING_FEE.readOnly = true;
        def.REVENUE_THIRD_PARTIES_OPERATION.readOnly = true;
        def.SPENDING_THIRD_PARTIES_OPERATION.readOnly = true;
        def.SALE_OF_HERITAGE.readOnly = true;
        def.SELF_FINANCING.readOnly = true;
        def.PREVIOUS_SURPLUS.readOnly = true;
        def.FCTVA_VALUE.readOnly = true;
        def.DEFICIT_RECOVERY.readOnly = true;
    }

    // _modifiedDef(def, index) {
    //   def.FCTVA.editableCells = index;
    //   def.PLANNING_FEE.editableCells = index;
    //   def.REVENUE_THIRD_PARTIES_OPERATION.editableCells = index;
    //   def.SPENDING_THIRD_PARTIES_OPERATION.editableCells = index;
    //   def.SALE_OF_HERITAGE.editableCells = index;
    //   def.DEFICIT_RECOVERY.editableCells = index;
    //   def.PREVIOUS_SURPLUS.editableCells = index;
    //   def.SELF_FINANCING.editableCells = index;
    //   def.SPENDING_THIRD_PARTIES_OPERATION.editableCells = index;
    //   def.FCTVA_RETRIEVE.editableCells = index;
    // }

    _resolveFindPPI(response) {
        const ppi = response;
        this.props.actions.setPageTitle(ppi.name);
        this.setState(
            {
                loadingGrants: true,
                loadingLoans: true,
                loadingUsers: true,
                loadingPpi: false,
                loadingStr: "Chargement des données complémentaires",
                ppi,
                rawPpi: response,
                notFound: false,
            },
            () => {
                LoansService.findLoans(this.props.currentLocalAuthority).then(
                    :: this._resolveFindLoans,
                    :: this._rejectFindLoans
                );
                UsersService.findAllUsers().then(
                    :: this._resolveFindUsers,
                    :: this._rejectFindUsers
                );
                GrantsService.findAllGrants(this.props.currentLocalAuthority.id).then(
                    :: this._resolveFindGrants,
                    :: this._rejectFindGrants
                );
                //this._resolveFindLoans(this.props.currentLocalAuthority.loans)
            }
        );
    }

    _rejectFindPPI(error) {
        this.setState({ loadingPpi: false, notFound: true });
        //::this._dispatchReceiveError(error);
    }

    _resolveFindLoans(response, ppi, callback) {
        const loans = response;
        ppi = ppi || this.state.ppi;
        if (ppi === null || ppi === undefined) return;
        const years = ppi.years.map((y) => y.year);
        const lds = getLoansWithDecomposition(loans);
        var yearLoans = [];
        var yearLoan;
        lds.forEach((ld) => {
            const decomposition = ld.decomposition;
            const loan = ld.loan;
            let decom = {
                interests: [],
                paymentAmounts: [],
                paymentDates: [],
                periodicRates: [],
                reimboursedCapitals: [],
                remainingCapitals: [],
            };
            decomposition.paymentDates.map((date, i) => {
                if (decomposition.remainingCapitals[i] > 0) {
                    decom.interests.push(decomposition.interests[i]);
                    decom.paymentAmounts.push(decomposition.paymentAmounts[i]);
                    decom.paymentDates.push(date);
                    decom.periodicRates.push(decomposition.periodicRates[i]);
                    decom.reimboursedCapitals.push(decomposition.reimboursedCapitals[i]);
                    decom.remainingCapitals.push(decomposition.remainingCapitals[i]);
                }
            });
            years.forEach((year) => {
                yearLoan = yearLoans.find((yl) => yl.year == year);
                if (!yearLoan) {
                    yearLoan = {
                        year: year,
                        total: 0,
                        reimbourse: 0,
                        interests: 0,
                        remaining: 0,
                        reimbours: 0,
                    };
                    yearLoans.push(yearLoan);
                }
                if (parseInt(moment(ld.loan.contractedOn).format("YYYY")) == year) {
                    yearLoan.total += ld.loan.amount; //getAnnuity(ld.decomposition, year)
                }

                if (isNaN(yearLoan.reimbourse)) yearLoan.reimbourse = 0;
                yearLoan.reimbourse += getYearReimboursedCapital(decomposition, year);
                if (isNaN(yearLoan.interests)) yearLoan.interests = 0;
                yearLoan.interests += getYearInterest(decomposition, year);
                if (isNaN(yearLoan.remaining)) yearLoan.remaining = 0;
                yearLoan.remaining += getYearRemainingCapital(decomposition, year);

                / Shifted year calculation Remborsement emprunts row /;
                if (isNaN(yearLoan.reimbours)) yearLoan.reimbours = 0;
                yearLoan.reimbours += getYearReimboursedCapital(decom, year);

                if (this.props.currentLocalAuthority.isDebtSimplified) {
                    const ppiYear = ppi.years.find(o => o.year === year);
                    if (ppiYear && ppiYear.loanDebtAmount != null) {
                        yearLoan.reimbourse = ppiYear.loanDebtAmount;
                    }
                }                
            });
        });
        if (callback) callback(yearLoans);
        else {
            this.setState(
                { loadingLoans: false, loans: yearLoans, rawLoans: loans },
                () => {
                    if (!this._isLoading()) {
                        this._getData();
                    }
                }
            );
        }
    }

    _rejectFindLoans(error) {
        this.setState({ loadingLoans: false }):: this._dispatchReceiveError(error);
    }

    _resolveFindUsers(response) {
        this.setState({ loadingUsers: false, users: response }, () => {
            if (!this._isLoading()) {
                this._getData();
            }
        });
    }

    _rejectFindUsers(error) {
        this.setState({ loadingUsers: false }):: this._dispatchReceiveError(error);
    }

    _resolveFindGrants(response) {
        this.setState({ loadingGrants: false, grants: response }, () => {
            if (!this._isLoading()) {
                this._getData();
            }
        });
    }

    _rejectFindGrants(error) {
        this.setState({ loadingGrants: false }):: this._dispatchReceiveError(error);
    }

    _resolveFindScenario(response) {
        this.setState(
            {
                loadingScenario: false,
                scenario: response == true ? null : response,
                findScenario: response == true ? false : true,
            },
            () => {
                if (!this._isLoading() && !this.state.findScenario) {
                    this._getData();
                }
            }
        );
    }

    _rejectFindScenario(error) {
        this.setState({ loadingScenario: false });
        this._dispatchReceiveError(error);
    }

    _handleChange = (
        owner,
        /** @type {CellInfo[]} */ cells,
        /** @type {String} */ source
    ) => {
        if (cells && source !== "loadData" && source !== "populateFromArray") {
            const def = TableDefinition(
                this.state.ppi,
                this.state.as_responsible,
                this.state.current_year,
                this.state.shownGrants,
                this.props.currentLocalAuthority,
                this.state.scenario
            );
            var ppi = this.state.ppi;
            var row, col, value, definition;
            var hasChanges = false,
                changeId;
            cells.map((cell) => {
                row = cell[0];
                col =
                    cell[1] -
                    1 +
                    this.state.ppi.years.filter((y) => y.year < this.state.current_year)
                        .length;
                value = cell[3];
                switch (owner) {
                    case "main":
                        definition = def.rows[row];
                        if (definition.mapping) {
                            value = parseInt(
                                Object.keys(definition.mapping).find(
                                    (key) => definition.mapping[key] == value
                                )
                            );
                        }
                        if (
                            (ppi.years[col][definition.property] &&
                                ppi.years[col][definition.property] !== value) ||
                            (!ppi.years[col][definition.property] &&
                                value !== "" &&
                                value !== null &&
                                value !== undefined)
                        ) {
                            ppi.years[col][definition.property] = value;
                            hasChanges = true;
                        }
                        break;
                    case "revenues":
                        if (ppi.revenues[row].years[col].value !== value) {
                            ppi.revenues[row].years[col].value = value;
                            hasChanges = true;
                        }
                        break;
                    case "expenses":
                        if (ppi.expenses[row].years[col].value !== value) {
                            ppi.expenses[row].years[col].value = value;
                            hasChanges = true;
                        }
                        break;
                }
                if (hasChanges) {
                    this.setState({ ppi }, () => {
                        setTimeout(() => {
                            this._getData();
                            switch (owner) {
                                case "main":
                                    PPIYearService.updatePPIYear(
                                        ppi.years[col].id,
                                        definition.property,
                                        value
                                    );
                                    break;
                                case "revenues":
                                    PPIRevenueYearService.updatePPIRevenueYear(
                                        ppi.revenues[row].years[col]
                                    );
                                    break;
                                case "expenses":
                                    PPIExpenseYearService.updatePPIExpenseYear(
                                        ppi.expenses[row].years[col]
                                    );
                                    break;
                            }
                        }, 500);
                    });
                }
            });
        }
    };

    _handlePrioritiesChanged(priorities) {
        this._getData();
        this.setState({ priorities });
    }

    _handleTogglePreviousYear() {
        // let index = [];
        // if (
        //   this.state.previousYear &&
        //   this.props.currentUser &&
        //   this.props.currentUser.userType &&
        //   this.props.currentUser.userType !== "SFP_ADMIN"
        // ) {
        //   index = [1, 2, 3, 4, 5, 6];
        // } else {
        //   index = [2, 3, 4, 5, 6];
        // }
        // let def = this.state.tableDef;
        // this._modifiedDef(def, index);
        // this.setState({ tableDef: def });

        this.setState(
            {
                previousYear: !this.state.previousYear,
                current_year:
                    this.state.current_year + (this.state.previousYear ? 1 : -1),
            },
            this._getData
        );
    }

    _handleYearAdded(ppi) {
        this._resolveFindLoans(this.state.rawLoans, ppi, (loans) => {
            this.setState(
                { action: null, actionData: null, ppi, loans },
                this._getData
            );
        });
    }

    _handleLastYearDeleted(ppi) {
        this._resolveFindLoans(this.state.rawLoans, ppi, (loans) => {
            this.setState(
                { action: null, actionData: null, ppi, loans },
                this._getData
            );
        });
    }

    _handleHidePopup() {
        if (
            this.state.action.indexOf("grant") !== -1 ||
            this.state.action == "popup_alter_project"
        ) {
            this.setState({ action: "alter_project" });
        } else {
            this.setState({ action: null, actionData: null });
        }
    }

    _handleCustomAction(type, data, callback) {
        this.setState({ action: type, actionData: data }, () => {
            if (callback) callback();
        });
        /*
    switch(type) {
    case "new_revenue":
    case "alter_revenue":
    case "destroy_revenue":
    this.setState({action: type, actionData: data})
    break
    }
    */
    }

    _handleRevenueCreated(revenue) {
        var ppi = this.state.ppi;
        ppi.revenues.push(revenue);
        this.setState({ action: null, ppi, actionData: null }, this._getData);
    }

    _handleRevenueUpdated(revenue) {
        var ppi = this.state.ppi;
        ppi.revenues.find((r) => r.id == revenue.id).name = revenue.name;
        this.setState({ action: null, ppi, actionData: null }, this._getData);
    }

    _handleRevenueDeleted(revenue_id) {
        var ppi = this.state.ppi;
        var revenues = [];
        for (var i in ppi.revenues) {
            if (ppi.revenues[i].id !== revenue_id) {
                revenues.push(ppi.revenues[i]);
            }
        }

        ppi.revenues = revenues;
        this.setState({ action: null, ppi, actionData: null }, this._getData);
    }

    _handleExpenseCreated(expense) {
        var ppi = this.state.ppi;
        ppi.expenses.push(expense);
        this.setState({ action: null, ppi, actionData: null }, this._getData);
    }

    _handleExpenseUpdated(expense) {
        var ppi = this.state.ppi;
        ppi.expenses.find((r) => r.id == expense.id).name = expense.name;
        this.setState({ action: null, ppi, actionData: null }, this._getData);
    }

    _handleExpenseDeleted(expense_id) {
        var ppi = this.state.ppi;
        var expenses = [];
        for (var i in ppi.expenses) {
            if (ppi.expenses[i].id !== expense_id) {
                expenses.push(ppi.expenses[i]);
            }
        }

        ppi.expenses = expenses;
        this.setState({ action: null, ppi, actionData: null }, this._getData);
    }

    _handleThemeCreated(investment_theme) {
        var ppi = this.state.ppi;
        if (investment_theme.parent) {
            ppi.investment_themes
                .find((it) => it.id == investment_theme.parent.id)
                .themes.push(investment_theme);
        } else {
            ppi.investment_themes.push(investment_theme);
        }
        this.setState({ action: null, ppi, actionData: null }, this._getData);
    }

    _handleThemeUpdated(investment_theme) {
        var ppi = this.state.ppi;
        var ts;
        var themes = [];
        if (investment_theme.parent) {
            ts = ppi.investment_themes.find(
                (it) => it.id == investment_theme.parent.id
            ).themes;
        } else {
            ts = ppi.investment_themes;
        }
        ts.map((theme) => {
            if (theme.id == investment_theme.id) themes.push(investment_theme);
            else themes.push(theme);
        });
        if (investment_theme.parent) {
            ppi.investment_themes.find(
                (it) => it.id == investment_theme.parent.id
            ).themes = themes;
        } else {
            ppi.investment_themes = themes;
        }
        this.setState({ action: null, ppi, actionData: null }, this._getData);
    }

    _handleThemeDeleted(investment_theme_id) {
        var ppi = this.state.ppi;
        var investment_themes = [];
        var investment_theme = ppi.investment_themes.find(
            (it) => it.id == investment_theme_id
        );
        if (!investment_theme) {
            for (var i in ppi.investment_themes) {
                if (
                    (investment_theme = ppi.investment_themes[i].themes.find(
                        (it) => it.id == investment_theme_id
                    ))
                ) {
                    for (var j in ppi.investment_themes[i].themes) {
                        if (ppi.investment_themes[i].themes[j].id !== investment_theme_id) {
                            investment_themes.push(ppi.investment_themes[i].themes[j]);
                        }
                    }
                    ppi.investment_themes[i].themes = investment_themes;
                    break;
                }
            }
        } else {
            for (var i in ppi.investment_themes) {
                if (ppi.investment_themes[i].id !== investment_theme_id) {
                    investment_themes.push(ppi.investment_themes[i]);
                }
            }

            ppi.investment_themes = investment_themes;
        }
        this.setState({ action: null, ppi, actionData: null }, this._getData);
    }

    _handleToggleTheme(data) {
        var shownThemes = this.state.shownThemes;
        if (shownThemes.indexOf(data.id) !== -1)
            shownThemes.splice(shownThemes.indexOf(data.id), 1);
        else shownThemes.push(data.id);
        this.setState({ shownThemes });
    }

    _handleProjectCreated(project) {
        var ppi = this.state.ppi;
        var theme;
        if (project.theme.parent) {
            theme = ppi.investment_themes
                .find((t) => t.id == project.theme.parent.id)
                .themes.find((t) => t.id == project.theme.id);
        } else {
            theme = ppi.investment_themes.find((t) => t.id == project.theme.id);
        }
        theme.projects.push(project);
        this.setState({ action: null, ppi, actionData: null }, this._getData);
    }

    _handleToggleGrantTheme(theme) { }

    _handleProjectUpdated(project) {
        var ppi = this.state.ppi;
        var t, theme, subtheme;
        if (project.theme.parent) {
            theme = ppi.investment_themes.find(
                (t) => t.id == project.theme.parent.id
            );
            subtheme = t = theme.themes.find((t) => t.id == project.theme.id);
        } else {
            theme = t = ppi.investment_themes.find((t) => t.id == project.theme.id);
        }

        var projects = [];
        if (t.projects.find((p) => p.id == project.id)) {
            // Theme not changed
            for (var i in t.projects) {
                if (t.projects[i].id !== project.id) {
                    projects.push(t.projects[i]);
                } else {
                    projects.push(project);
                }
            }

            t.projects = projects;
        } else {
            // Theme has changed
            var oldTheme;
            for (var i in ppi.investment_ts) {
                oldTheme = ppi.investment_ts[i];
                if (oldTheme.projects.find((p) => p.id == project.id)) {
                    break;
                } else {
                    for (var j in oldTheme.oldThemes) {
                        oldTheme = oldTheme.oldThemes[j];
                        if (oldTheme.projects.find((p) => p.id == project.id)) {
                            break;
                        } else {
                            oldTheme = null;
                        }
                    }
                    if (oldTheme) break;
                }
            }

            if (oldTheme) {
                for (var i in oldTheme.projects) {
                    if (oldTheme.projects[i].id !== project.id) {
                        projects.push(oldTheme.projects[i]);
                    }
                }
                oldTheme.projects = projects;
            }
            t.projects.push(project);
        }

        this.setState(
            {
                action: "alter_project",
                ppi,
                actionData: { project, theme, subtheme },
            },
            this._getData
        );
    }

    _handleToggleGrants(type) {
        var shownGrants = this.state.shownGrants;
        var index;
        if ((index = shownGrants.indexOf(type)) !== -1) {
            shownGrants.splice(index, 1);
        } else {
            shownGrants.push(type);
        }
        this.setState({ shownGrants }, this._getData);
    }

    _handleToggleProject(project) {
        var ppi = this.state.ppi;
        /*
    if (project.theme.parent) {
    theme = ppi.investment_themes.find(t => t.id == project.theme.parent.id).themes.find(t => t.id == project.theme.id)
    } else {
    theme = ppi.investment_themes.find(t => t.id == project.theme.id)
    }
    var project = theme.projects.find(p => p.id == project.id)
    */

        var project_id = project.id;
        var project, theme, subtheme;
        for (var i in ppi.investment_themes) {
            theme = ppi.investment_themes[i];
            if ((project = theme.projects.find((p) => p.id == project_id))) break;
            for (var j in theme.themes) {
                subtheme = theme.themes[j];
                if (subtheme.projects.length > 0) {
                    if ((project = subtheme.projects.find((p) => p.id == project_id)))
                        break;
                }
            }
            if (project) break;
        }
        project.visible = !project.visible;
        this.setState({ ppi: ppi }, this._getData);
    }

    _handleProjectDeleted(data) {
        data = JSON.parse(data);
        var ppi = this.state.ppi;
        var theme;
        if (!(theme = ppi.investment_themes.find((t) => t.id == data.theme_id))) {
            for (var i in ppi.investment_themes) {
                if (
                    (theme = ppi.investment_themes[i].themes.find(
                        (it) => it.id == data.theme_id
                    ))
                )
                    break;
            }
        }

        var projects = [];
        for (var i in theme.projects) {
            if (theme.projects[i].id !== data.project_id) {
                projects.push(theme.projects[i]);
            }
        }

        theme.projects = projects;
        this.setState({ action: null, ppi, actionData: null }, this._getData);
    }

    _handleGrantCreated(grant) {
        var ppi = this.state.ppi;
        var theme;
        if (grant.project.theme.parent) {
            theme = ppi.investment_themes
                .find((t) => t.id == grant.project.theme.parent.id)
                .themes.find((t) => t.id == grant.project.theme.id);
        } else {
            theme = ppi.investment_themes.find((t) => t.id == grant.project.theme.id);
        }
        theme.projects.find((p) => p.id == grant.project.id).grants.push(grant);
        this.setState({ action: "alter_project", ppi }, this._getData);
    }

    _handleGrantUpdated(grant) {
        var ppi = this.state.ppi;
        var theme;
        if (grant.project.theme.parent) {
            theme = ppi.investment_themes
                .find((t) => t.id == grant.project.theme.parent.id)
                .themes.find((t) => t.id == grant.project.theme.id);
        } else {
            theme = ppi.investment_themes.find((t) => t.id == grant.project.theme.id);
        }

        var project = theme.projects.find((p) => p.id == grant.project.id);

        var grants = [];
        for (var i in project.grants) {
            if (project.grants[i].id !== grant.id) {
                grants.push(project.grants[i]);
            } else {
                grants.push(grant);
            }
        }

        project.grants = grants;
        this.setState({ action: "alter_project", ppi }, this._getData);
    }

    _handleGrantDeleted(data) {
        data = JSON.parse(data);
        var ppi = this.state.ppi;
        var theme;
        var theme;
        if (!(theme = ppi.investment_themes.find((t) => t.id == data.theme_id))) {
            for (var i in ppi.investment_themes) {
                if (
                    (theme = ppi.investment_themes[i].themes.find(
                        (it) => it.id == data.theme_id
                    ))
                )
                    break;
            }
        }

        var project = theme.projects.find((p) => p.id == data.project_id);

        var grants = [];
        for (var i in project.grants) {
            if (project.grants[i].id !== data.grant_id) {
                grants.push(project.grants[i]);
            }
        }

        project.grants = grants;
        this.setState({ action: "alter_project", ppi }, this._getData);
    }

    _handleProjectsDataBuild = (data, rows) => {
        this.setState({ projectsData: { data, rows } });
    };
}

PPIDetailContainer.childContextTypes = {
    onCustomAction: React.PropTypes.function
};

const guid = () => {
    let s4 = () => {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
    );
};

const mapStateToProps = (state) => ({
    currentLocalAuthority: state.currentLocalAuthority,
    currentUser: state.currentUser,
    pageTitle: state.title,
    selectedPriorities: state.selectedPriorities,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PPIDetailContainer);



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/ppi-detail-container.js